(function(){
  'use strict';

  eclipseApp.constant('errorCodeMap', {
    '500': {
      title: 'global.error.label.technicalError',
      desc: 'global.error.postBack.technicalError'
    },
    '5000': {
      title: 'global.error.label.technicalError',
      desc: 'global.error.postBack.technicalError'
    },
    '50000': {
      title: 'global.error.label.technicalError',
      desc: 'global.error.postBack.technicalError'
    },
    '50003': {
      title: 'global.error.label.technicalError',
      desc: 'global.error.postBack.technicalError'
    },
    '80001': {
      title: 'global.error.label.technicalError',
      desc: 'global.error.postBack.technicalError'
    },
    '60000': {
      title: 'global.error.label.invalidSerialNumber',
      desc: 'global.error.postBack.serial.invalid'
    },
    '1049581': {
      title: 'global.error.label.error',
      desc: 'global.error.postBack.invalidRequest'
    },
    '60003': {
      title: 'global.error.label.error',
      desc: 'global.error.postBack.bank.invalid'
    },
    '1049577': {
      title: 'global.error.label.error',
      desc: 'global.error.postBack.invalidRequest'
    },
    'cybinvalid':{
      title: 'global.error.label.error',
      desc: 'global.error.postBack.creditCard.invalid'
    },
    'smpciinvalid':{
      title: 'global.error.label.error',
      desc: 'global.error.postBack.creditCard.swipe'
    },
    '60004': {
      title: 'global.error.label.error',
      desc: 'global.error.postBack.sin.invalid'
    },
    '2000092': {
      title: 'global.error.label.error',
      desc: 'global.error.postBack.orderConfirmation'
    },
    '600015': {
      title: '',
      desc: 'global.error.inline.customer.existingV1',
      templateUrl: 'modules/checkout/views/fragments/modal/contact-footer.html'
    },
    '8001010': {
      title: 'global.error.label.error',
      desc: 'global.error.postBack.semafone.8001010'
    },
    '8001020': {
      title: 'global.error.label.error',
      desc: 'global.error.postBack.semafone.8001020'
    },
    '8001030': {
      title: 'global.error.label.error',
      desc: 'global.error.postBack.semafone.8001030'
    },
    '8002010': {
      title: 'global.error.label.error',
      desc: 'global.error.postBack.semafone.8002010'
    },
    '8002020': {
      title: 'global.error.label.error',
      desc: 'global.error.postBack.semafone.8002020'
    },
    '8003010': {
      title: 'global.error.label.error',
      desc: 'global.error.postBack.semafone.8003010'
    },
    '8003011': {
      title: 'global.error.label.error',
      desc: 'global.error.postBack.semafone.8003011'
    },
    '1002010': {
      title: 'global.error.label.error',
      desc: 'global.error.postBack.cybersource.1002010'
    },
    '1002011': {
      title: 'global.error.label.error',
      desc: 'global.error.postBack.cybersource.1002011'
    },
    '1002012': {
      title: 'global.error.label.error',
      desc: 'global.error.postBack.cybersource.1002012'
    },
    '1004010': {
      title: 'global.error.label.error',
      desc: 'global.error.postBack.cybersource.1004010'
    },
    '100893': {
      title: 'global.error.label.error',
      desc: 'global.error.postBack.semafone.8003010'
    }
  });

  eclipseApp.factory('notifier', ['$modal', '$timeout', 'errorCodeMap', 'buyUtils', function($modal, $timeout, errorCodeMap, buyUtils){

    /*
     * @var _phase
     * @states:
     *
     * @state Error State
     * -
     *
     * @state Default Error State
     * -
     *
     * @state Info State
     * -
     *
     *
     */

    var notifier = {},
        _delay = 10000,
        _delayMax = 180000,
        _loadingPhase,
        _lastPhase,
        _phase = {},
        _defaultConfig,
        modalInstance,
        modalConfig;

    var setConfig = function(params){

      params = params || {};
      params.errorCode = params.errorCode || undefined;
      params.templateUrl = params.templateUrl || undefined;
      params.title = params.title || 'UnTitled';
      params.desc = params.desc || 'More Description';
      
      params.keyboard = params.keyboard || false;
      params.backdrop = params.backdrop || 'static';

      //console.log('@seConfig(@params) ', params);
      _defaultConfig = {
        templateUrl: 'modules/checkout/views/notify.html',
        controller: 'NotifierModalCtrl',
        keyboard: params.keyboard,
        backdrop: params.backdrop,
        resolve: {
          data: function(){
            return {
              error: { code: params.errorCode },
              templateUrl: params.templateUrl,
              title: params.title,
              desc: params.desc
            };
          }
        }
      };
      return _defaultConfig;
    };

    var initLastPhase = function(){
      //console.log('@initLastPhase: INITIALIZED');
      _lastPhase = $timeout(function(){
      }, _delayMax);

      _lastPhase.then(function(){
        console.log('@notifier: PHASE TIMEDOUT: _lastPhase');
        buyUtils.cancelOperation();
        angular.copy({last: true}, _phase);
      });
    };

    var initPhase = function(){
      //console.log('@initPhase:_delay ', _delay);
      _loadingPhase = $timeout(function(){
      }, _delay);

      _loadingPhase.then(function(){
        console.log('@notifier: PHASE TIMEDOUT: _loadingPhase');
        angular.copy({two: true}, _phase);

        initLastPhase();
      });
    };

    notifier = {
      resetDelay: function(delay){
        delay = delay || undefined;
        _delay = notifier.incDelay(delay);

        // console.log('@notifier.resetDelay: @_loadingPhase:BEFORE', _loadingPhase);
        // console.log('@notifier.resetDelay: @_lastPhase:BEFORE ', _lastPhase);
        // console.log('@notifier.resetDelay: @_phase:BEFORE ', _phase);

        if (!_phase.error){
          if (_loadingPhase){
            $timeout.cancel(_loadingPhase);

            initPhase();
          }
        } else if (_phase.error && _loadingPhase) {
          $timeout.cancel(_loadingPhase);
        }

      },
      incDelay: function(incNum){
        _delay += incNum || 5000;
        return _delay;
      },
      phase: _phase,
      cancelAllPhases: function(){
        if (_loadingPhase) {
          /*
           * @if
           * if _loadingPhase has not timed-out -> cancel it
           * 
           */
          $timeout.cancel(_loadingPhase);
        }

        if (_lastPhase){
          /*
           * @if 
           * if _lastPhase has not timed-out -> cancel it
           */
          $timeout.cancel(_lastPhase);
        }
      },
      cleanupInstance: function(){
        if (modalInstance && modalInstance.result){
          modalInstance.result.then(function(resp){
            console.log('--1# result', resp);
          }, function(resp){
            console.log('--2# result', resp);
          }).finally(function(resp){
            console.log('--3# result', resp);
            modalInstance = null;
          });
        }
      }
    };

    notifier.notify = {
      processing: function(){
        console.log('@notifier: INIT PROCESSING (_loadingPhase) ', _loadingPhase);

        // prevent multiple processing modal once one is instantiated
        if (_loadingPhase || _lastPhase) notifier.cancelAllPhases();
        if (modalInstance) {
          modalInstance.close();
        }

        modalConfig = setConfig();
        modalInstance = $modal.open(modalConfig);

        angular.copy({}, _phase);

        // console.log('@notifier.processing: @_loadingPhase ', _loadingPhase);
        // console.log('@notifier.processing: @_phase ', _phase);

        initPhase();
        console.log('@notifier INIT PROCESSING ENDING (modalInstance, _loadingPhase) ', modalInstance, _loadingPhase);
      },
      done: function(param){
        //console.log('@notifier.notify.done: @_loadingPhase ', _loadingPhase );
        //console.log('@notifier.notify.done: @_lastPhase ', _lastPhase );

        notifier.cancelAllPhases();

        //console.log('@notifier:done():(modalInstance) ', modalInstance);
        if (modalInstance) {
          modalInstance.dismiss();
        }
        
      },

      /*
       * @name error
       * @description handle cases of instantiation as 'standalone' or 'follow-up'
       */
      error: function(errorData){
        console.log('@notifier.notify.error BEGINS: (_loadingPhase, _lastPhase, modalInstance, errorData) ', _loadingPhase, _lastPhase, modalInstance, errorData);

        errorData = errorData || {};
        errorData.errorCode = errorData.errorCode || undefined;
        errorData.riskClassCode = errorData.riskClassCode || undefined;
        errorData.templateUrl = errorData.templateUrl || undefined;
        modalConfig = setConfig(errorData);

        notifier.cancelAllPhases();

        if (modalInstance && modalInstance.opened) {
          // handle case follow-up

          modalInstance.opened.then(function(resp){
            console.log('--1# opened', resp);

            
            if (!errorData.errorCode){
              //handle wo errorCode
              console.log('@notifier.notify.error IF1');


              /*
               * @if
               * @property errorCode of @param errorData
               * if value of errorCode is undefined in @param errorData
               * -> show default error state:oops
               * 
               */
              angular.copy({last: true}, _phase); 
              return;
            } 
            else if (errorData.riskClassCode) {
              console.log('@notifier.notify.error IF1 > IF1');
              angular.copy({error: true, data: errorData}, _phase);
              return;
            } 
            else {
              //handle w errorCode
              console.log('@notifier.notify.error ELSE1');

              /*
               * @else
               * @property errorCode of @param errorData 
               * if errorCode is defined 
               * -> expose data to service for controllers to consume
               * -> show specific error case message if errorCode match in list 
               * -> if list did not match, show default error state:oops
               *
               */
              angular.copy({error: true, data: errorData}, _phase);
            }
          }, function(resp){
            console.log('--2# opened', resp);
            modalInstance = $modal.open(modalConfig);
          });

          if (modalInstance && modalInstance.result){
            notifier.cleanupInstance();
          }
        } else {
          // handle case standalone
          modalInstance = $modal.open(modalConfig);

          
          if (errorData.errorCode) {
            // handle with errorCode
            angular.copy({error: true, data: errorData}, _phase); // show defined error
          } else {
            // handle wo errorCode
            angular.copy({last: true}, _phase); // show oops
          }

          if (modalInstance && modalInstance.result){
            notifier.cleanupInstance();
          }
        } 
        

        // if (modalInstance) {
        //   console.log('@notifier.notify.error IF2');
        //   /*
        //    * @if
        //    * handle: showing error modal alone;
        //    * if a modalInstance still exist dismiss it
        //    * then open a new instance with a new config with the errorCode data
        //    */
        //   // modalInstance.dismiss();
        //   // modalInstance = $modal.open(modalConfig);
        //   return;
        // }

        // if (!modalInstance) {
        //   console.log('@notifier.notify.error IF3');
        //   /*
        //    * @if
        //    * if no modalInstance exist -> start a new one with the errorCode data 
        //    */
        //   modalInstance = $modal.open(modalConfig);
        //   return;
        // }


      },
      info: function(msgObj){

        console.log('---@notifier: INIT INFO (msgObj)', msgObj);

        msgObj = msgObj || {};
        msgObj.title = msgObj.title || 'Untitled';
        msgObj.desc = msgObj.desc || 'More information';

        angular.copy({info: true, data: msgObj}, _phase);

        if (modalInstance) {
          console.log('---@notifier: INPROG ', modalInstance);
          modalInstance.dismiss();
        }

        console.log('---@notifier: ENDING CALL ', modalInstance);

        modalConfig = setConfig(msgObj);
        modalInstance = $modal.open(modalConfig);

      }
    };

    return notifier;
  }]);
})();
